import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Review_contract_table from "./review_contract_table/Review_contract_table";

import { useDispatch, useSelector } from "react-redux";
import { GetAll } from "../../../../../../features/admin/quality_management/process_requirement/tender/Slice";
import Review_Form from "./review_Form/Review_Form";
import Review_Edit from "./review_Edit/Review_Edit";
import { FixIDS } from "../../../../../../utils/fixIDS";


function Review_contract() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const all_customer_details = useSelector((state) => state.tender);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const permissions = useSelector((state) => state.auth.permissions);
                            
  const haveReadPermission = permissions?.includes(FixIDS.review_of_request.List);
  const haveAddPermission = permissions?.includes(FixIDS.review_of_request.Add); //form

  useEffect(() => {
    dispatch(
      GetAll({
        page: currentPage,
        per_page: all_customer_details.per_page,
      }),
    );
  }, [dispatch, currentPage]);
  const handleEdit = (id) => {
    setEditId(id);
    setIsEdit(true);
  };
  return (
    <>
      <section className="Imperiality Quality_Policy  ScopeOfTheLaboratory">
        {/* <div className="back_div">
          <Common_Back_Btn backText="Review Of Request , Tenders & Contract" />
        </div>
        <div className="white_container customer_section">
          <div className="note_text_holder">
            <p>
              Review of Requests, Tenders, and Contracts involves a detailed
              evaluation of all received inquiries, tender documents, and
              contractual terms to ensure compliance with requirements, clarity
              of scope, and risk identification before approval.
            </p>
          </div>
        </div> */}
        {isEdit ? (
          <>
            <div className="back_div">
              <Common_Back_Btn backText="Edit tendor" onClick={() => setIsEdit(false)}/>
            </div>
            <Review_Edit id={editId} onCancel={() => setIsEdit(false)} />
          </>
        ) : (
          <>
            <div className="imperiality_Form_div">
              { haveAddPermission && <Review_Form />}
            </div>

            <div className="imperiality_table_div">
              { haveReadPermission && <Review_contract_table
                all_customer_details={all_customer_details}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                onEdit={handleEdit}
              /> }
            </div>
          </>
        )}
      </section>
    </>
  );
}

export default Review_contract;
